module.exports = __webpack_public_path__ + "img/f-bg.7b35ec75.png";